<template>
    <div v-if="loading" class="loading-container">
        <!--        <div class="spinner"></div>-->
        <div class="lds-dual-ring"></div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Loading',
    computed: {
        ...mapGetters({
            loading: 'spinner/loading'
        })
    },
    created () {
        setTimeout(() => {
            if (this.loading) {
                this.$stopSpinner()
                // this.$showError({ message: 'Timeout' })
            }
        }, 15000)
    }
}
</script>

<style scoped lang="scss">
    .loading-container {
        background-color: $background;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1500;
        top: 0;
        height: 100%;
        width: 100%;

        .lds-dual-ring {
            display: inline-block;
            position: absolute;
            width: 46px;
            height: 46px;
            /*left: 50%;*/
            /*top: 50%;*/
            /*transform: translate(-50%, -50%);*/

            &:after {
                content: " ";
                display: block;
                width: 46px;
                height: 46px;
                margin: 1px;
                border-radius: 50%;
                border: 5px solid;
                border-color: #0098C5 transparent #0098C5 transparent;
                animation: lds-dual-ring 1.2s linear infinite;
            }
        }

        @keyframes lds-dual-ring {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }

    /*.spinner {*/
    /*    position: absolute;*/
    /*    left: 50%;*/
    /*    top: 50%;*/
    /*    transform: translate(-50%, -50%);*/
    /*}*/

    /*.spinner {*/
    /*    display: inline-block;*/
    /*    width: 80px;*/
    /*    height: 80px;*/
    /*}*/

    /*.spinner:after {*/
    /*    content: " ";*/
    /*    display: block;*/
    /*    width: 80px;*/
    /*    height: 80px;*/
    /*    border-radius: 50%;*/
    /*    border: 3px solid;*/
    /*    border-color: #23B8DC transparent #23B8DC transparent;*/
    /*    animation: spinner 1.2s linear infinite;*/
    /*}*/

    /*@keyframes spinner {*/
    /*    0% {*/
    /*        transform: rotate(0deg);*/
    /*    }*/
    /*    100% {*/
    /*        transform: rotate(360deg);*/
    /*    }*/
    /*}*/

</style>
